import ActionLogsTableApp from "../Functionality/ActionLogsTableApp";
import CustomTable from "../../../../components/table/CustomTable";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ActionLogsTab = ({modified, setModified, modelType, finalArray}) => {
    // Destructure table configuration and pagination
    const {
        tableId,
        thead,
        tbody,
        getActionsButtons,
        pagination
    } = ActionLogsTableApp({
        modified,
        setModified,
        modelType,
        finalArray
    });

    return (
        <>
            <CustomTable tableId={tableId}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         getActionsButtons={getActionsButtons}
            />
            { pagination() }
        </>
    );
};

export default ActionLogsTab;
